import { DialogDescription } from '@/components/Dialog';
import { cn } from '@/utils';

function Description({ className, ...props }) {
	return (
		<DialogDescription asChild>
			<p
				className={cn(
					'text-xs leading-5 text-grey-500 md:text-sm md:leading-6',
					className
				)}
				{...props}
			/>
		</DialogDescription>
	);
}

export default Description;
